import { RotateCcw } from "lucide-react";

export const ProgressEmptyState = ({ activeSummary, onResetFilters }) => (
  <div
    className="app-card border border-dashed border-[var(--border-primary)] p-10 text-center"
    data-testid="progress-empty-state"
  >
    <h2 className="font-heading text-2xl tracking-wider uppercase text-dark-text-primary">No Matching Activities</h2>
    <p className="text-sm text-dark-text-secondary mt-3">
      The request succeeded, but no activities matched your current filters.
    </p>
    {activeSummary ? (
      <p className="text-xs text-dark-text-muted mt-3" data-testid="progress-empty-filter-summary">
        Current filters: {activeSummary}
      </p>
    ) : null}
    <p className="text-xs text-dark-text-muted mt-2">
      Try a wider date range or a different sport filter. This is not a server error.
    </p>
    {onResetFilters ? (
      <button
        type="button"
        onClick={onResetFilters}
        className="btn-secondary-app mt-6 px-6 py-3 text-xs tracking-[0.15em] uppercase min-h-[44px]"
        data-testid="progress-reset-filters"
      >
        <RotateCcw className="w-4 h-4" strokeWidth={2} aria-hidden="true" />
        Reset Filters
      </button>
    ) : null}
  </div>
);
